import React, { useState, useEffect, useReducer } from 'react';
import { useParams } from 'react-router-dom';
import FileUploader from 'devextreme-react/file-uploader';
import Button from 'devextreme-react/button';
import * as actions from '../../actions/siteDetails';
import siteReducer from '../../reducers/siteDetails';
import { fileTypeInfo } from '../../common/utils'
import CONFIG from "./../../common/config";

const initialState = { layoutFileInfo: null };

const LayoutFiles = (props) => {
    const { site, tier, } = useParams();
    const [selectedFiles, setSelectedFiles] = useState([])
    const [fileType, setFileType] = useState(null)
    const [isUploaded, setIsUploaded] = useState(false)
    const [state, dispatch] = useReducer(siteReducer, initialState);
    const { layoutFileInfo } = state
    const onFileSelect = e => {
        let type = e.value[0].type
        let val;
        if (type.indexOf('pdf') > -1)
            val = 'pdf'
        else if (type.indexOf('image') > -1)
            val = 'img'
        setFileType(val)
        setSelectedFiles(e.value);

    };
    const isValidFile = () => fileType === 'pdf' || fileType === 'img'

    const url = CONFIG.API_ENDPOINT;


    useEffect(() => {
        if (layoutFileInfo && layoutFileInfo.path) {
            let path = url.slice(0, -1) + layoutFileInfo.path
            let tpl;
            tpl = `<img src="${path}" width="100%" />`;
            if ('application/pdf' === selectedFiles[0]['type'])
                tpl = `<object data='${path}' width="100%" height="500"></object>`;
            props.onImgUpload(tpl)
            setIsUploaded(true)
        }
    }, [layoutFileInfo])

    const onUpload = () => {
        let formData = new FormData();
        formData.append('filedata', selectedFiles[0] ? selectedFiles[0] : null)
        actions.saveLayoutFile(dispatch, formData, `siteuid=${site}&tierId=${tier}`)

    }

    return (
        <div>
            {!isUploaded && <><div className="dx-field">
                <FileUploader className="dx-field-value" selectButtonText="Choose file" labelText="Max. File Size 4 MB" allowedFileExtensions={['.jpeg', '.png', '.pdf', '.jpg', '.gif']} accept="*" uploadMode="useForm" onValueChanged={onFileSelect} value={selectedFiles} />
                <div className="dx-field-value">{fileTypeInfo(['JPEG', 'PNG', 'PDF', 'JPG', 'GIF'])}</div>
            </div>
                <div className="dx-field">
                    <Button text="Upload" disabled={!isValidFile()} onClick={onUpload} />
                </div></>
            }
            {isUploaded && <div className="dx-field">
                <br />
                <div>File uploaded successfully.</div>
                <br />
                <div className="dx-field">
                    <Button text="Change file" onClick={() => { setSelectedFiles([]); setIsUploaded(false) }} />
                </div>
            </div>}

        </div>
    );
}

export default LayoutFiles